module.exports = __webpack_public_path__ + "media/assets/icons/chevrons/chevron-down-6690f8aecc8c08b402d2531824d090c5.svg";